/* Mini cart drawer. Exposes window.BuyazyCart.open(justAdded) */
(function () {
  'use strict';
  var T = window.theme || {};
  var el = document.querySelector('[data-bzcd]');
  if (!el) return;
  var body = el.querySelector('[data-bzcd-body]');
  var foot = el.querySelector('[data-bzcd-foot]');
  var sub = el.querySelector('[data-bzcd-subtotal]');
  var added = el.querySelector('[data-bzcd-added]');
  var lastFocus = null;

  function money(c) {
    var fmt = T.moneyFormat || '${{amount}}';
    var a = (c / 100).toFixed(2), w = a.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount\s*\}\}/g, w)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(c / 100).toLocaleString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, a.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(c / 100)));
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function thumb(url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=160';
  }
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (b) { b.textContent = n; b.hidden = n < 1; });
  }

  function render(cart) {
    setCount(cart.item_count);
    if (!cart.item_count) {
      body.innerHTML = '<div class="bzcd-empty"><p>Your cart is empty.</p></div>';
      foot.hidden = true;
      return;
    }
    foot.hidden = false;
    sub.textContent = money(cart.total_price);
    body.innerHTML = '<ul class="bzcd-items">' + cart.items.map(function (it, i) {
      var v = it.variant_title && it.variant_title !== 'Default Title' ? '<span class="bzcd-var">' + esc(it.variant_title) + '</span>' : '';
      var was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
      return '<li class="bzcd-item" data-line="' + (i + 1) + '" data-qty="' + it.quantity + '">' +
        '<a class="bzcd-thumb" href="' + it.url + '">' + (it.image ? '<img src="' + thumb(it.image) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="bzcd-info">' +
          '<a class="bzcd-name" href="' + it.url + '">' + esc(it.product_title) + '</a>' + v +
          '<div class="bzcd-row">' +
            '<span class="bzcd-qty"><button type="button" data-bzcd-step="-1" aria-label="Decrease quantity">&minus;</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-bzcd-step="1" aria-label="Increase quantity">+</button></span>' +
            '<span class="bzcd-price">' + was + money(it.final_line_price) + '</span>' +
          '</div>' +
          '<button type="button" class="bzcd-remove" data-bzcd-remove>Remove</button>' +
        '</div></li>';
    }).join('') + '</ul>';
  }

  function load() {
    return fetch(T.cartUrl + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(render);
  }

  function change(line, qty) {
    body.style.opacity = '.55';
    fetch(T.cartUrl + '/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(render)
      .catch(load).then(function () { body.style.opacity = ''; });
  }

  function open(justAdded) {
    lastFocus = document.activeElement;
    if (added) added.hidden = !justAdded;
    if (!body.innerHTML) body.innerHTML = '<p class="bzcd-loading">Loading&hellip;</p>';
    el.hidden = false;
    document.body.classList.add('bzcd-lock');
    void el.offsetWidth; /* commit the closed state so the slide-in animates */
    el.classList.add('open');
    load().then(function () {
      var c = el.querySelector('.bzcd-checkout');
      if (c && !foot.hidden) c.focus({ preventScroll: true });
    }).catch(function () { window.location.href = T.cartUrl; });
  }
  function close() {
    el.classList.remove('open');
    document.body.classList.remove('bzcd-lock');
    setTimeout(function () { el.hidden = true; }, 300);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  el.addEventListener('click', function (e) {
    if (e.target.closest('[data-bzcd-close]')) { close(); return; }
    var li = e.target.closest('[data-line]');
    if (!li) return;
    var line = +li.getAttribute('data-line'), q = +li.getAttribute('data-qty');
    var step = e.target.closest('[data-bzcd-step]');
    if (step) change(line, Math.max(0, q + (+step.getAttribute('data-bzcd-step'))));
    else if (e.target.closest('[data-bzcd-remove]')) change(line, 0);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !el.hidden) close();
  });

  window.BuyazyCart = { open: open, close: close };

  /* Open the drawer whenever something is added to the cart — hooks the
     store's own add-to-cart request, so theme.js doesn't need changing. */
  var addPath = (T.cartAddUrl || '/cart/add').split('?')[0];
  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = nativeFetch.apply(this, arguments);
      if (url.indexOf(addPath) > -1) {
        p.then(function (r) { if (r.ok) setTimeout(function () { open(true); }, 0); }).catch(function () {});
      }
      return p;
    };
  }
}());
